import { Reference } from '@/types/models';
import { AnnotationItem } from '@/components/Map/Drawer/BioEntityDrawer/AnnotationItem/AnnotationItem.component';
import React from 'react';
import { ONE, ZERO } from '@/constants/common';

type AnnotationItemListProps = {
  references: Reference[];
};

export const AnnotationItemList = ({ references }: AnnotationItemListProps): React.ReactNode => {
  const isReferenceAvailable = references.length > ZERO;
  const sortedReferences = references.slice();
  sortedReferences.sort((a, b) => {
    if (a.type < b.type) {
      return -ONE;
    }
    if (a.type > b.type) {
      return ONE;
    }
    return ZERO;
  });

  function uniqBy(a: Reference[]): Reference[] {
    const seen: Map<string, boolean> = new Map();
    return a.filter((item: Reference) => {
      const k = `${item.type}:${item.resource}`;
      if (seen.get(k)) {
        return false;
      }
      seen.set(k, true);
      return true;
    });
  }

  const filteredReferences = uniqBy(sortedReferences);

  return (
    <div>
      <h3 className="font-semibold">
        Annotations: {!isReferenceAvailable && <span className="font-normal">No annotations</span>}
      </h3>
      <div className="flex max-h-full flex-col gap-2 overflow-x-hidden pt-2">
        {isReferenceAvailable &&
          filteredReferences.map(reference => (
            <AnnotationItem
              key={reference.id}
              type={reference.type}
              link={reference.link}
              resource={reference.resource}
            />
          ))}
      </div>
    </div>
  );
};
